import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M4 7v7h12V7l-6 4z', 'M15.697 6H4.303L10 9.798z'],
  height: 20,
  width: 20,
});
